import { render, staticRenderFns } from "./CustomValidator.form.vue?vue&type=template&id=1550053c&scoped=true&"
import script from "./CustomValidator.form.vue?vue&type=script&lang=js&"
export * from "./CustomValidator.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1550053c",
  null
  
)

export default component.exports